import { Button, Form, FormInstance, Radio, Row } from "antd";
import { useEffect, useMemo } from "react";
import { FloatNumberInput } from "../../../../components/FloatNumberInput";
import { useAmountRules } from "../../hooks/useAmountRules";
import { Comments } from "./Comments";
import { useCompleteStep } from "../../hooks/useCompleteFirstStep";

type FormDataProps = {
  form: FormInstance;
  amount: number;
  setStep: React.Dispatch<React.SetStateAction<number>>;
  setRequest: React.Dispatch<React.SetStateAction<any>>;
};

export const FormData = ({
  amount,
  form,
  setStep,
  setRequest,
}: FormDataProps) => {
  const amountOption = Form.useWatch("amountOption", form);

  const { onNext } = useCompleteStep(form, setStep, setRequest);

  const amountOptions = useMemo(
    () => [
      {
        value: 1,
        label: (
          <Row className="d-block">
            <h4 className="h h4">${amount.toFixed(2)}</h4>
            <p className="my-0 text-md title">Regular Amount</p>
          </Row>
        ),
      },
      {
        value: 2,
        label: "Custom Amount",
      },
    ],
    [amount],
  );

  useEffect(() => {
    form.setFields([
      {
        name: ["comments"],
        value: "",
        errors: [],
      },
    ]);
    form.setFieldValue("amount", amountOption === 1 ? amount.toFixed(2) : "");
  }, [amountOption, form, amount]);

  const { rules } = useAmountRules(amountOption === 1);

  return (
    <>
      <p className="mt-0 mb-2 text w-500">Payment Amount</p>
      <Form.Item name="amountOption" className="mb-4">
        <Radio.Group options={amountOptions} className="amount-options" />
      </Form.Item>
      <FloatNumberInput
        form={form}
        name="amount"
        className={`pr-1 mb-4 ${amountOption === 1 ? "d-none" : ""}`}
        label=" "
        rules={rules}
        includeThousandsSeparator
      />
      <Comments amountOption={amountOption} form={form} />

      <Button type="primary" shape="round" size="large" onClick={onNext}>
        Next to Payment Method
      </Button>
    </>
  );
};
